'use strict';

angular.module('mobile-apps')
	.factory('CacheDataLoad', [
		'$q',
		function($q
		) {

			var factory = {};

			factory._data = {};
			factory._activeRequests = {};


			/**
			 * Adds a callback to get called once the currently active request
			 * gets resolved
			 * @param modelName The name of the model the data gets requested for (identifier)
			 * @param entryId The id of the entry to get the data of
			 * @param callbackFunction The callback function to call once data got received
       		 */
			factory._addActiveRequest = function(modelName, entryId, callbackFunction) {
				var me = this;
				if (!me._activeRequests.hasOwnProperty(modelName)) {
					me._activeRequests[modelName] = {};
				}

				if (!me._activeRequests[modelName].hasOwnProperty(entryId)) {
					me._activeRequests[modelName][entryId] = [];
				}

				me._activeRequests[modelName][entryId].push(callbackFunction);
			};


			/**
			 * Checks if there is currently an active request
			 * @param modelName The name of the model to check (identifier)
			 * @param entryId The id of the entry to check
			 * @returns {boolean}
			 */
			factory._checkRequestActive = function(modelName, entryId) {
				var me = this;
				if (!me._activeRequests.hasOwnProperty(modelName)) {
					return false;
				}

				if (!me._activeRequests[modelName].hasOwnProperty(entryId)) {
					return false;
				}

				if (me._activeRequests[modelName][entryId].length === 0) {
					return false;
				}

				return true;
			};


			/**
			 * Checks if the requested data is already cached and returns it
			 * available
			 * @param modelName The name of the model to get data of (identifier)
			 * @param entryId The id of the entry to get
		     * @returns {*}
		     */
			factory._getCacheData = function(modelName, entryId) {
				var me = this;

				if (!me._data.hasOwnProperty(modelName)) {
					return null;
				}

				if (!me._data[modelName].hasOwnProperty(entryId)) {
					return null;
				}

				return me._data[modelName][entryId];
			};


			/**
			 * Adds data to cache
			 * @param modelName The name of the model to set data of (identifier)
			 * @param entryId The id of the entry to set
			 * @param data The data to set
			 */
			factory._setCacheData = function(modelName, entryId, data) {
				var me = this;

				if (!me._data.hasOwnProperty(modelName)) {
					me._data[modelName] = {};
				}

				if (!me._data[modelName].hasOwnProperty(entryId)) {
					me._data[modelName][entryId] = {};
				}

				me._data[modelName][entryId] = data;
			};


			/**
			 * Clears all the data in the cache for a specific model
			 * @param modelName The name of the model of which data should be cleared
			 * @returns {boolean}
			 */
			factory.clearCache = function(modelName) {
				var me = this;

				if (!modelName) {
					// If no modelName is given nothing gets cleared
					return false;
				}

				if (!me._data.hasOwnProperty(modelName)) {
					// If there is no data there is nothing to clear
					return true;
				}

				// Reset the model data
				me._data[modelName] = {};
			};


			/**
			 * Requests data and checks first if it got already cached before
			 * and makes sure that if data gets requested multiple times at the
			 * same time it makes just a single request
			 * @param getModelDataFunction Function which requests data from server
			 * @param modelName The name of the model to get data of (identifier)
			 * @param entryId The id of the entry to get
			 * @param forceRefresh If set to true it does not check cache for data
			 * @returns {*}
			 */
			factory.getData = function(getModelDataFunction, modelName, entryId, forceRefresh, cb) {
				var me = this;

				var returnPromise;
				if (!cb) {
					// If no callback is given we return a promise
					returnPromise = $q(function (resolve, reject) {
						cb = function (err, data) {
							if (err) {
								return reject(err);
							}
							resolve(data);
						};
					});
				}

				// If data does not have to get refreshed we check if it is
				// already cached
				if (!forceRefresh) {
					var cachedData = me._getCacheData(modelName, entryId);
					if (cachedData !== null) {
						cb(null, cachedData);
						return returnPromise;
					}
				}

				// If no cached data gets returned check if there is already
				// a active request for the same data
				if (me._checkRequestActive(modelName, entryId)) {
					// If there is an active request we add the current one to
					// the list and return
					me._addActiveRequest(modelName, entryId, cb);
					return returnPromise;
				}

				// Add the callback so that it gets called after the data
				// got received
				me._addActiveRequest(modelName, entryId, cb);

				// If there are no active requests we start a new one
				getModelDataFunction(entryId, function(err, data) {

					if (!err) {
						// Add data only to cache if request was successful
						me._setCacheData(modelName, entryId, data);
					}

					// Resolve all the waiting callbacks
					me._activeRequests[modelName][entryId].forEach(function(currentCallback) {
						currentCallback(err, data);
					});
					// Reset the active requests
					me._activeRequests[modelName][entryId].length = 0;
				});

				return returnPromise;
			};


			return factory;
		}
	]);
